import { useMemo } from "react";
import { useAsyncData } from "../../hooks/useAsyncData";
import * as api from "../../lib/claimsApi.ts";
import type { EvidenceMetadata } from "@shared/types/claims.ts";

/** Fetches the display-only metadata of a verification's evidence, keyed by source id. Errors are
 *  swallowed: the metadata only adds notes to source cards, so its absence must not break the page. */
export function useEvidenceMetadata(
  userEventVerificationId: string | undefined
): Map<string, EvidenceMetadata> {
  const { data } = useAsyncData(async () => {
    if (!userEventVerificationId) return [];
    try {
      const { items } = await api.fetchEvidenceMetadata(userEventVerificationId, [
        "publication_types",
      ]);
      return items;
    } catch {
      return [];
    }
  });

  return useMemo(() => new Map((data ?? []).map((item) => [item.source_id, item])), [data]);
}
